const scrollMargin = {
  name: "scroll-margin",
  path: "scroll-margin",
  title: "scroll-margin",
  description: "Utilities for controlling the CSS scroll-margin properties.",
  value: {
    "scroll-margin": {
      "scroll-m-<number>": "scroll-margin: calc(var(--1) * <number>);",
      "-scroll-m-<number>": "scroll-margin: calc(var(--1) * -<number>);",
      "scroll-m-[<value>]": "scroll-margin: <value>;",
      "scroll-mx-<number>": "scroll-margin-inline: calc(var(--1) * <number>);",
      "-scroll-mx-<number>": "scroll-margin-inline: calc(var(--1) * -<number>);",
      "scroll-mx-[<value>]": "scroll-margin-inline: <value>;",
      "scroll-my-<number>": "scroll-margin-block: calc(var(--1) * <number>);",
      "-scroll-my-<number>": "scroll-margin-block: calc(var(--1) * -<number>);",
      "scroll-my-[<value>]": "scroll-margin-block: <value>;",
      "scroll-mt-<number>": "scroll-margin-top: calc(var(--1) * <number>);",
      "-scroll-mt-<number>": "scroll-margin-top: calc(var(--1) * -<number>);",
      "scroll-mt-[<value>]": "scroll-margin-top: <value>;",
      "scroll-mr-<number>": "scroll-margin-right: calc(var(--1) * <number>);",
      "-scroll-mr-<number>": "scroll-margin-right: calc(var(--1) * -<number>);",
      "scroll-mr-[<value>]": "scroll-margin-right: <value>;",
      "scroll-mb-<number>": "scroll-margin-bottom: calc(var(--1) * <number>);",
      "-scroll-mb-<number>": "scroll-margin-bottom: calc(var(--1) * -<number>);",
      "scroll-mb-[<value>]": "scroll-margin-bottom: <value>;",
      "scroll-ml-<number>": "scroll-margin-left: calc(var(--1) * <number>);",
      "-scroll-ml-<number>": "scroll-margin-left: calc(var(--1) * -<number>);",
      "scroll-ml-[<value>]": "scroll-margin-left: <value>;"
    }
  },
  exampleData: [
    {
      title: "scroll-m-4, scroll-mx-8, scroll-mt-2",
      description: "Set scroll margin on elements for scroll positioning:",
      example: {
        code: `<div class="scroll-m-4 ...">scroll-margin: 1rem</div>
<div class="scroll-mx-8 ...">scroll-margin-inline: 2rem</div>
<div class="scroll-mt-2 ...">scroll-margin-top: 0.5rem</div>`
      }
    }
  ],
  htmlData: [
    {
      title: "Scroll margin",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">scroll-m-*</code> utilities to control scroll-margin properties of an element.
      </p>
      <div class="flex w-full snap-x gap-12 overflow-x-auto py-14 *:whitespace-nowrap *:border *:border-color-gray-200">
        <div class="scroll-m-4 bg-blue-100 rounded p-2">scroll-m-4</div>
        <div class="scroll-mx-8 bg-green-100 rounded p-2">scroll-mx-8</div>
        <div class="scroll-mt-2 bg-yellow-100 rounded p-2">scroll-mt-2</div>
        <div class="scroll-m-4 bg-blue-100 rounded p-2">scroll-m-4</div>
        <div class="scroll-mx-8 bg-green-100 rounded p-2">scroll-mx-8</div>
        <div class="scroll-mt-2 bg-yellow-100 rounded p-2">scroll-mt-2</div>
        <div class="scroll-m-4 bg-blue-100 rounded p-2">scroll-m-4</div>
        <div class="scroll-mx-8 bg-green-100 rounded p-2">scroll-mx-8</div>
        <div class="scroll-mt-2 bg-yellow-100 rounded p-2">scroll-mt-2</div>
      </div>
      `
    }
  ]
};

export default scrollMargin;
      <div class="flex w-full snap-x gap-12 overflow-x-auto py-14 *:whitespace-nowrap *:border *:border-color-gray-200">
        <div class="scroll-m-4 bg-blue-100 rounded p-2">scroll-m-4</div>
        <div class="scroll-mx-8 bg-green-100 rounded p-2">scroll-mx-8</div>
        <div class="scroll-mt-2 bg-yellow-100 rounded p-2">scroll-mt-2</div>
      </div>